import axios from "axios";
import protoRoot from "../proto/proto"
import protobuf from 'protobufjs';

// 兼容低版本IE
axios.interceptors.response.use(
    response => {
        // IE 8-9 
        if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
            try {
                // eslint-disable-next-line no-param-reassign
                response.data = JSON.parse(response.request.responseText);
            } catch (e) {
                // ignored
            }
        }
        return response;
    }
)

function parseUrlParams(url) {
    var params = url.split("?");
    if (params.length > 1) {
        params = params[1];
    } else {
        params = params[0]
    }
    var paramArr = params.split('&');
    var res = {};
    for (var i = 0; i < paramArr.length; i++) {
        var str = paramArr[i].split('=');
        res[str[0]] = str[1];
    }
    return res;
}
let OWAPPAPIHOST = "";
const sendOwappServer = function (path, data, cb) {
    axios.get(OWAPPAPIHOST + path, {
        params: data
    }).then((response) => {
        // console.log(path, response.data);
        response.data = parseUrlParams(response.data);
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(error);
        cb ? cb(error, null) : null;
    });
}

let kdtsApi = process.env.NODE_ENV === 'development' ? "/api/kdts" : "https://kdts.ionewu.com";
const sendKdtsApi = function (path, data, cb) {
    axios.post(kdtsApi + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(error);
        cb ? cb(error, null) : null;
    });
}

let tanApi = process.env.NODE_ENV === 'development' ? "/api/tan" : "https://tan.ionewu.com";
const sendTanApi = function (path, data, cb) {
    axios.post(tanApi + path, data).then((response) => {
        // console.log(tanApi + path);
        // console.log(response.data);
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(tanApi + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}
const sendTanApiGet = function (path, data, cb) {
    data.v = new Date().getTime();
    axios.get(tanApi + path, {
        params: data
    }).then((response) => {
        // console.log(tanApi + path);
        // console.log(response.data);
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(tanApi + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}

let api = process.env.NODE_ENV === 'development' ? "/api/c" : "https://c.ionewu.com";
const post = function (path, data, cb) {
    axios.post(api + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(api + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });

}
const get = function (path, data, cb) {
    data.cache_ver = Math.random();
    axios.get(api + path, {
        params: data
    }).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(api + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}
let jdisApi = process.env.NODE_ENV === 'development' ? "/api/jdis" : "https://jdis.ionewu.com";
const jdisGet = function (path, data, cb) {
    data.cache_ver = Math.random();
    axios.get(jdisApi + path, {
        params: data
    }).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(jdisApi + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}
const jdisPost = function (path, data, cb) {
    axios.post(jdisApi + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        console.log(jdisApi + path);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}

let pbPost = function (url, pbName, params, cb) {
    const httpService = axios.create({
        timeout: 45000,
        method: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/octet-stream'
        },
        responseType: 'arraybuffer'
    })

    let ProtoReq = protoRoot.lookup(pbName + "Req");
    let reqObj = ProtoReq.create(params);
    const xy = process.env.NODE_ENV === 'development' ? "" : "";
    httpService.post(xy + url, reqObj, {
        transformRequest: function (data) {
            //将json编码为二进制
            let reqBuf = ProtoReq.encode(data).finish();
            return reqBuf;
        }
    }).then(function (data) {
        let buf = protobuf.util.newBuffer(data.data);
        let ProtoResp = protoRoot.lookup(pbName + 'Resp')
        //将二进制解码为json
        let decodedResponse = ProtoResp.decode(buf);
        if (process.env.NODE_ENV != 'production') {
            console.log(reqObj);
            console.log(decodedResponse);
        }
        cb ? cb(null, decodedResponse) : null;
    }).catch((error) => {
        console.log(xy + url);
        console.log(error);
        cb ? cb(error, null) : null;
    });
}

let statApi = process.env.NODE_ENV === 'development' ? "https://stat.ionewu.com" : "http://stat.ionewu.com";
const statPost = function (path, data, cb) {
    axios.post(statApi + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

export default {
    updateHttp: function () {
        kdtsApi = kdtsApi.replace("https:", "http:");
        tanApi = tanApi.replace("https:", "http:");
        api = api.replace("https:", "http:");
        jdisApi = jdisApi.replace("https:", "http:");
        statApi = statApi.replace("https:", "http:");
    },
    updateToSameSiteApi: function () {
        this.updateCApi("/api/c");
        this.updateTanApi("/api/tan");
        this.updateKdtsApi("/api/kdts");
        this.updateJdisApi("/api/jdis");
    },
    updateCApi: function (value) {
        api = value;
    },
    updateTanApi: function (value) {
        tanApi = value;
    },
    updateKdtsApi: function (value) {
        kdtsApi = value;
    },
    updateJdisApi: function (value) {
        jdisApi = value;
    },
    stat: {
        alive: function (data, cb) {
            statPost("/run/rpt/alive", data, cb);
        }
    },
    owapp: {
        setLocalApiHost: function (api, cb) {
            OWAPPAPIHOST = api;
            cb ? cb() : null;
        },
        getSysInfo: function (data, cb) {
            sendOwappServer("/sys/info", data, cb)
        },
    },
    user: {
        getExchange: function (data, cb) {
            sendTanApi("/api/jdxb/user/exchange", data, cb);
        },
        addWakeup: function (data, cb) {
            sendTanApi("/api/jdxb/user/wakeup/add", data, cb);
        },
        delWakeup: function (data, cb) {
            sendTanApi("/api/jdxb/user/wakeup/del", data, cb);
        },
        getWakeups: function (data, cb) {
            sendTanApiGet("/api/jdxb/user/wakeup/list", data, cb);
        },
        getServerTimes: function (data, cb) {
            sendTanApiGet("/api/jdxb/user/server/times", data, cb);
        },
        updateServerTimes: function (data, cb) {
            sendTanApi("/api/jdxb/user/server/times", data, cb);
        },
        log: function (data, cb) {
            sendTanApi("/api/jdxb/log/user", data, cb);
        },
        phoneLogin: function (data, cb) {
            post("/phone/login2", data, cb);
        },
        login: function (data, cb) {
            post("/wx/account/auth", data, cb);
        },
        sendCode: function (data, cb) {
            get("/phone/captcha2", data, cb);
        },
        sendLoginBindCode: function (data, cb) {
            get("/captcha/phone/get", data, cb);
        },
        loginBind: function (data, cb) {
            get("/captcha/bind/phone", data, cb);
        },
        imagebackup: {
            log: function (data, cb) {
                sendTanApi("/api/jdxb/log/imagebackup", data, cb);
            },
            list: function (data, cb) {
                sendTanApiGet("/api/jdxb/log/imagebackup", data, cb);
            },
            getPath: function (data, cb) {
                sendTanApiGet("/api/jdxb/device/imagebackup/path", data, cb);
            },
            setPath: function (data, cb) {
                sendTanApi("/api/jdxb/device/imagebackup/path", data, cb);
            }
        },
    },
    node: {
        getUserConfig: function (data, cb) {
            sendTanApiGet("/api/jdxb/user/config", data, cb);
        },
        postUserConfig: function (data, cb) {
            sendTanApi("/api/jdxb/user/config", data, null);
        },
        deviceName: function (data, cb) {
            sendTanApi("/api/jdxb/device/name", data, cb);
        },
        nodeDeviceInfo: function (data, cb) {
            sendTanApi("/api/jdxb/device/info", data, cb);
        },
        deviceBandwidth: function (data, cb) {
            sendTanApi("/api/jdxb/device/bandwidth", data, cb);
        },
        bookRegister: function (data, cb) {
            post("/jdb/book/register", data, cb);
        },
        getPid: function (data, cb) {
            get("/dev/pid/query", data, cb);
        },
        unbind: function (data, cb) {
            get("/air/jdb/clean", data, cb);
        },
        register: function (data, cb) {
            post("/jdb/book/register", data, cb);
        },
        webWakeup: function (data, cb) {
            jdisPost("/jdis/wakeup", data, cb);
        },
        nodelistset: function (data, cb) {
            jdisPost("/jdis/nodelistset", data, cb);
        },
        scanlist: function (data, cb) {
            jdisGet("/jdis/scanlist", data, cb);
        },
        speclist: function (data, cb) {
            jdisGet("/jdis/speclist", data, cb);
        },
        scan: function (data, cb) {
            jdisPost("/jdis/scan", data, cb);
        },
        usrdata: function (data, cb) {
            jdisGet("/jdis/usrdata", data, cb);
        },
        usrdataset: function (data, cb) {
            jdisPost("/jdis/usrdataset", data, cb);
        },
        nodelist: function (data, cb) {
            jdisGet("/jdis/nodelist", data, cb);
        },
        nodeupdate: function (data, cb) {
            jdisPost("/jdis/nodeupdate", data, cb);
        },
        bindget: function (data, cb) {
            jdisGet("/jdis/bindget", data, cb);
        },
        bindset: function (data, cb) {
            jdisPost("/jdis/bindset", data, cb);
        },
        portal: function (data, cb) {
            jdisGet("/jdis/portal", data, cb);
        },
        createTunnel: function (data, cb) {
            let path = "/jdis/createTunnel";
            if (data.uid) {
                path = path + "?uid=" + data.uid;
                delete data.uid;
            }
            pbPost(data.addr + path, "JDCreateTunnel", data, cb);
        },
        startMapSrv: function (data, cb) {
            let path = "/jdis/startMapSrv";
            if (data.uid) {
                path = path + "?uid=" + data.uid;
                delete data.uid;
            }
            pbPost(data.addr + path, "JDStartMapSrv", data, cb);
        },
    },
    mall: {
        kdts: {
            query: function (data, cb) {
                sendKdtsApi("/c/query", data, cb);
            }
        },
        goods: {
            list: function (data, cb) {
                post("/jdb/goods/list", data, cb);
            },
            exchange: function (data, cb) {
                post("/jdb/goods/exchange", data, cb);
            }
        },
        hot: {
            today: function (data, cb) {
                sendTanApiGet("/api/jdb/user/rank/today", data, cb);
            },
            threeDays: function (data, cb) {
                sendTanApiGet("/api/jdb/user/rank/threeday", data, cb);
            }
        },
        exchange: {
            list: function (data, cb) {
                post("/jdb/exchange/list", data, cb);
            }
        },
        user: {
            info: function (data, cb) {
                post("/jdb/user/info", data, cb);
            },
            points: function (data, cb) {
                post("/jdb/user/points", data, cb);
            },
        },
        fulu: {
            order: function (data, cb) {
                sendTanApi("/fulupay/UnifiedOrder", data, cb);
            },
            query: function (data, cb) {
                sendTanApi("/fulupay/OrderQuery", data, cb);
            }
        },
    },
    speed: {
        cacheclean: function (data, cb) {
            get("/jdb/cacheclean", data, cb);
        },
        limitset: function (data, cb) {
            post("/jdb/limit/set", data, cb);
        },
        limitget: function (data, cb) {
            post("/jdb/limit/get", data, cb);
        },
        readguideget: function (data, cb) {
            get("/jdb/xbjs/readguideget", data, cb);
        },
        readguideset: function (data, cb) {
            get("/jdb/xbjs/readguideset", data, cb);
        },
    },
    speedTelescope: {
        goods: function (data, cb) {
            post("/jdgj/goods", data, cb);
        },
        left: function (data, cb) {
            post("/jdgj/left", data, cb);
        },
        unifiedOrder: function (data, cb) {
            sendTanApi("/pay/UnifiedOrder", data, cb);
        },
        orderQuery: function (data, cb) {
            sendTanApi("/pay/OrderQuery", data, cb);
        },
    },
    speedShare: {
        points: function (data, cb) {
            post("/jdb/device/points", data, cb);
        },
        deviceInfo: function (data, cb) {
            post("/jdb/device/info", data, cb);
        },
    },
    userInfo: {
        feedback: function (data, cb) {
            sendTanApi("/api/jdxb/user/feedback", data, cb);
        },
        userFile: function (data, cb) {
            sendTanApi("/api/jdxb/user/file", data, cb);
        },
        userGrowthTake: function (data, cb) {
            sendTanApi("/api/jdxb/user/growth/take", data, cb);
        },
        userSigninInfo: function (data, cb) {
            sendTanApi("/api/jdxb/user/signin/info", data, cb);
        },
        userGrowthInfo: function (data, cb) {
            sendTanApi("/api/jdxb/user/growth/info", data, cb);
        },
        getAgree: function (data, cb) {
            sendTanApiGet("/api/jdxb/user/agree", data, cb)
        },
        setAgree: function (data, cb) {
            sendTanApi("/api/jdxb/user/agree", data, cb)
        },
        info: function (data, cb) {
            post("/jdb/user/info", data, cb);
        },
        points: function (data, cb) {
            post("/jdb/user/points", data, cb);
        },
    },
    applications: {
        miniappList: function (data, cb) {
            get("/jdb/miniapp/list", data, cb);
        },
        miniappStatus: function (data, cb) {
            post("/jdb/miniapp/status", data, cb);
        },
        miniappAgree: function (data, cb) {
            post("/jdb/miniapp/agree", data, cb);
        },
    }
}